import { error, log } from './log';

const readCookie = name => {
    const index = document.cookie.indexOf(`${name}=`);

    return index > -1 ? document.cookie.substring(index).split(';')[0].split('=')[1] : '';
};

export const getRequestHeaders = () =>
    ['iPlanetDirectoryPro', 'ipAllowListJwtToken'].reduce(
        (previous, current) => ({ ...previous, [current]: readCookie(current) }),
        {}
    );

export const onFetchPackagesOnStartComplete =
    (onFetchPackagesOnStartCompleteHandler, onFetchPackagesOnCompleteHandler) => depsNotFound => {
        if (depsNotFound) {
            // eslint-disable-next-line no-unused-expressions
            onFetchPackagesOnCompleteHandler && onFetchPackagesOnCompleteHandler(depsNotFound);
            error('ERROR - files not found: ', depsNotFound);

            return;
        }

        onFetchPackagesOnStartCompleteHandler && onFetchPackagesOnStartCompleteHandler();
    };

export const getFetchPackagesList = (packageConfigMap, pkgList) =>
    pkgList.reduce((previous, current) => previous.concat(packageConfigMap[current] || current), []);

export const packageNameToUrlResolver = (packageConfigMap, packageName) => {
    if (!packageConfigMap || !packageConfigMap[packageName]) {
        log(`ERROR: Module config for ${packageName} not found.`);

        return [];
    }

    return packageConfigMap[packageName];
};
